import React, { PropTypes as T } from 'react';
import U from './tooltip_utils';
import assign from 'lodash/assign';

export default React.createClass({
  displayName: 'Tooltip',

  propTypes: {
    children: T.node,
    selector: T.string,
    dismissOnScroll: T.bool,
    focusSelector: T.string,
    closeSelector: T.string,
    labeledBy: T.string
  },

  componentDidMount () {
    const element = document.querySelector(this.props.selector);

    if (element) {
      element.addEventListener('click', this.updateDims);
      element.addEventListener('keypress', this.onKeyPressUpdateDims);
      if (this.props.dismissOnScroll) {
        document.addEventListener('scroll', this.hideTooltip);
      }
      this.refs.overlay.addEventListener('click', this.hideTooltip);
    }

    if (this.props.closeSelector) {
      const closeButtons = document.querySelectorAll(this.props.closeSelector);
      closeButtons.forEach((el) => {
          el.addEventListener('click', this.hideTooltip);
          el.addEventListener('keypress', this.onKeyPressHideTooltip);
      });
    }
  },

  componentWillUnmount () {
    const element = document.querySelector(this.props.selector);

    if (element) {
      element.removeEventListener('click', this.updateDims);
      element.removeEventListener('keypress', this.onKeyPressUpdateDims);
      if (this.props.dismissOnScroll) {
        document.removeEventListener('scroll', this.hideTooltip);
      }
      this.refs.overlay.removeEventListener('click', this.hideTooltip);
    }

    if (this.props.closeSelector) {
      const closeButtons = document.querySelectorAll(this.props.closeSelector);
      closeButtons.forEach((el) => {
          el.removeEventListener('click', this.hideTooltip);
          el.removeEventListener('keypress', this.onKeyPressHideTooltip);
      });
    }
  },

  onKeyPressUpdateDims (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      this.updateDims(e);
    }
  },

  onKeyPressHideTooltip (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      this.hideTooltip(e);
    }
  },

  hideTooltip (e) {
    this.setState(this.getInitialState());
    const element = document.querySelector(this.props.selector);
    if (element) {
       element.focus();
    }
  },

  updateDims (e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState(
      assign({}, this.state, {
        overlayStyles: assign({}, this.state.overlayStyles, {
          display: 'block'
        })
      })
    );

    const targetDims = e.target.getBoundingClientRect();
    const selfDims = this.refs.tooltip.getBoundingClientRect();
    const transforms = U.getTooltipPosition(selfDims, targetDims, window);

    const newStyles = {
      transform: `translate(${transforms.left}px, ${transforms.top}px)`,
      WebkitTransform: `translate(${transforms.left}px, ${transforms.top}px)`,
      msTransform: `translate(${transforms.left}px, ${transforms.top}px)`
    };

    this.setState(
      assign({}, this.state, {
        tooltipStyles: assign({}, this.state.tooltipStyles, newStyles)
      })
    );

    if (this.props.focusSelector) {
       const element = document.querySelector(this.props.focusSelector);
        if (element) {
          element.focus();
        }
    }
  },

  getInitialState () {
    return {
      overlayStyles: {
        display: 'none'
      },
      tooltipStyles: {
        transform: 'translate(0px, 0px)',
        WebkitTransform: 'translate(0px, 0px)',
        msTransform: 'translate(0px, 0px)'
      }
    };
  },

  render () {
    return (
      <div
        data-component="tooltip_overlay"
        ref="overlay"
        className="c-tooltip_overlay"
        style={this.state.overlayStyles}
      >
        <div
          role="dialog"
          data-component="tooltip"
          ref="tooltip"
          className="c-tooltip"
          style={this.state.tooltipStyles}
          aria-labelledby={this.props.labeledBy}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./frontend/react/components/common/tooltip/tooltip.js